module.exports={
    download_title: 'Make wealth within reach',
    download_description: 'Everything you need — in UPlus',
    download_robot: 'Automated Quant Trading Bot',
    download_trusted: 'Trusted by Millions of Crypto Investors',
    ios_profile_download: 'iOS profile download (recommended)'
}